

import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';

export class RouteListItem extends Component {

    constructor(props) {
      super(props);
      this.state = {
        isPanelOpen: false
      }

    }

    onCollapse = (e) => {
      this.setState({
        isPanelOpen: !this.state.isPanelOpen
      })
    }

    onSelect = (e) => {
      this.props.onRouteSelect(this.props.routeData._id);
    }

    selectedInfoClass = () => {
      return (this.props.routeData.selected ? 'route-info-selected' : null );
    }

    selectedIconClass = () => {
      return "fa route-check-square " + (this.props.routeData.selected ? 'fa-check-square' : 'fa-square-o' );
    }

    openPanelIcon = () => {
      return (this.state.isPanelOpen ? 'fa-compress' : 'fa-expand' );
    }

    selectedRouteLiClass = () => {
      return  (this.props.routeData.selected ? 'selected-route-item' : '' );
    }

    getLayerColorBox = () => {
      if (this.props.routeData.selected) {
        return (
        <span className="layer-color-icon pull-right">
        <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
            <rect style={{strokeWidth: 1, stroke: 'black', fill:this.props.routeData.pathColor}} x="0" y="0" width="10" height="10" rx="3" ry="3"/>
        </svg>
        </span>
      )} else {
          return '';
      }
    }

    render () {
        return (

          <li className={ 'route-item ' + this.selectedRouteLiClass()}>
            <span>
             <i onClick={ this.onSelect } className={this.selectedIconClass()}></i>
             <span className={"m-l-xs " +  this.selectedInfoClass()}>
               <span className="route-item-data">
                {this.props.routeData.from.name}
               </span>
               <span className="route-item-data">
                {this.props.routeData.to.name}
               </span>
               <span className="route-item-data">
                Miles: {this.props.routeData.km}
               </span>
               <span className="route-item-data">
                Revenue: $ {this.props.routeData.revenue} 
               </span>
            </span>


            <i onClick={ this.onCollapse } className={'fa route-info-icon pull-right ' +this.openPanelIcon()}></i>

            {this.getLayerColorBox()}

           </span>
           <Collapse in={this.state.isPanelOpen}>
           <div>
             <span className="route-extended-info">
              <table className="table">
                   <tbody>
                   <tr>
                       <td>Drive</td>
                       <td>{this.props.routeData.drive} hr</td>
                       <td>Duty</td>
                       <td>{this.props.routeData.duty} hr</td>
                       <td>Time</td>
                       <td>{this.props.routeData.time} hr</td>
                   </tr>
                   <tr>
                       <td>Off</td>
                       <td>{this.props.routeData.off} hr</td>
                       <td>Berth</td>
                       <td>{this.props.routeData.berth} $</td>
                       <td>Fuel</td>
                       <td>{this.props.routeData.fuel} lt</td>
                   </tr>
                   </tbody>
               </table>
               </span>
             </div>
             </Collapse>
          </li>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/RouteListItem.js